import { handleEvent } from '../../helpers';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default class {
  constructor(el) {
    this.el = el;
    this.form
  }

  init() {
    this.handleEvents();
  }

  handleEvents() {
    this.submit = handleEvent('click', {
      el: this.el.querySelector('input[type="submit"]'),
      preventDefault: true,
      stopPropagation: false,
      callback: this.formSubmit.bind(this)
    });
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

 async register(val) {
   const data = val;
   const url = this.form.getAttribute('action') + '&EMAIL=' + data;

   try {
     const response = await fetch(url, {
       method: 'get',
       mode: 'no-cors',
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
       },
     });

     const json = await response;
     if(json) {
       this.form.querySelector('span.done').classList.add('opacity-100');

       setTimeout(() => {
         this.form.querySelector('span.done').classList.remove('opacity-100');
         this.form.querySelector('input[type="email"]').value = '';
       },3000);
     }

   } catch (error) {
     console.error('Ошибка:', error);
   }
  }

  formSubmit(element) {
   let formVal = element.target.closest('form').querySelector('input[type="email"]').value;
   this.form = element.target.closest('form');
    if(this.validateEmail(formVal)) {
        this.register(formVal);
      element.target.closest('form').querySelector('span.error').classList.remove('opacity-100');
      } else {
        element.target.closest('form').querySelector('span.error').classList.add('opacity-100');
      }
  }

  destroy() {
    this.submit.destroy();
  }
}

// function validateEmail(email) {
//   const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//   return re.test(email);
// }
//
// let $formTime = $('.form-action').data('time');
//
// $(document).ready(function () {
//   let $form = $('.form-action form');
//
//   if ($form.length > 0) {
//     $('.form-action form input[type="submit"]').on('click', function (event) {
//       event.preventDefault();
//
//       let email = $('.form-action form input[type="email"]').val();
//
//       if(validateEmail(email)) {
//         register($form);
//       } else {
//         $('.error').text(email + " is not valid");
//       }
//     });
//   }
//
//   function register($form) {
//     $.ajax({
//       type: $form.attr('method'),
//       url: $form.attr('action'),
//       data: $form.serialize(),
//       cache: false,
//       dataType: 'json',
//       contentType: "application/json; charset=utf-8",
//       error: function (err) {
//         console.log(err)
//       },
//       success: function (data) {
//         console.log(data);
//         if (data.result != 'success') {
//           $('.error').text(data.msg.split('. <a')[0]);
//         } else {
//           const time = new Date(Date.now() + (180 * 24 * 60 * 60 * 1000))
//           document.cookie =
//             'klaClosedPopup=1' +
//             '; expires=' + time.toUTCString() +
//             '; path=/';
//
//           $('.error').text();
//           $('.form-action form').fadeOut(300);
//           $('.form-action svg').fadeOut();
//           $('.form-action h1').fadeIn(600);
//
//           setTimeout(function () {
//             $('.form-action').fadeOut(600);
//           },2000);
//         }
//       }
//     });
//   }
// });
